import React from "react";
import { Box, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { sliderClasses } from "@mui/material/Slider";

import MzTooltip from "@markaaz/ui/MzTooltip";
import MzSlider from "@markaaz/ui/MzSlider";
import { valueLabelFormat, scaleUpCurrency, scaleDownCurrency } from "../../Application/Decisioning/slider";

const sxRow = {
  root: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: "15px",
    height: "118px",
    maxWidth: "860px",
    color: "darkBlue.c100",
    background: "white",
    borderRadius: "8px"
  },
  label: {
    fontWeight: 600,
    paddingLeft: "40px"
  },
  icon: {
    color: "lightBlue.c100"
  },
  slider: {
    [`&.${sliderClasses.root}`]: {
      width: "402px",
      marginRight: "40px"
    },
    [`.${sliderClasses.rail}`]: {
      background: (theme) => theme.palette.common.gradientRisk2
    }
  }
};

export default function MatchingRow({ rowData, values = {}, onSliderChange }) {
  const label = rowData.label;
  const tooltip = rowData.tooltipContent;
  const isPremiumUser = values.isPremium;
  const isPremiumService = rowData.premium;
  const classes = [sxRow.root];

  if (rowData._do_not_render) return;

  if ((!isPremiumUser && isPremiumService) || rowData.checkboxKey === false) {
    classes.push(sxRow.premium);
  }

  if (rowData.slider || (!isPremiumUser && isPremiumService)) {
    classes.push(sxRow.slider);
  }

  function handleScale(value) {
    return getScaleUpValue(value);
  }

  function getScaleUpValue(value) {
    if (rowData.slider.scale === "currency") {
      return scaleUpCurrency(rowData.slider.marks, value);
    } else {
      return value * -1;
    }
  }

  function getScaleDownValue(value) {
    if (rowData.slider.scale === "currency") {
      return scaleDownCurrency(rowData.slider.marks, value);
    } else {
      return value * -1;
    }
  }

  let initialSliderValue = 0;
  if (rowData.slider) {
    const value = Number(values[rowData.slider.valueKey]);

    if (isNaN(value)) {
      initialSliderValue = 0;
    } else {
      initialSliderValue = value;
    }

    if (rowData.slider.scale) {
      initialSliderValue = getScaleDownValue(initialSliderValue);
    }
  }

  function handleSliderChange(_, value) {
    let newValue = value;
    if (rowData.slider.scale) {
      newValue = getScaleUpValue(value);
    }
    onSliderChange(_, newValue);
  }

  return (
    <Box sx={classes}>
      <Typography variant="body2" sx={sxRow.label}>
        {label}
      </Typography>
      <Box flexGrow={1}></Box>
      <MzSlider
        value={initialSliderValue}
        onChange={handleSliderChange}
        min={rowData.slider.min}
        max={rowData.slider.max}
        marks={rowData.slider.marks}
        step={rowData.slider.step}
        scale={rowData.slider.scale && handleScale}
        valueLabelFormat={rowData.slider.valueLabelFormat && valueLabelFormat(rowData.slider.valueLabelFormat)}
        track={rowData.slider.track}
        sx={sxRow.slider}
        variant={rowData.slider.variant}
      />

      <MzTooltip
        title={tooltip}
        arrow
        PopperProps={{
          modifiers: [{ name: "preventOverflow", options: { padding: 20 } }]
        }}
      >
        <InfoOutlinedIcon sx={sxRow.icon}></InfoOutlinedIcon>
      </MzTooltip>
    </Box>
  );
}
